import { Configuration, generateAuthConfiguration } from '@storable/next-okta';
import type { NextApiRequest, NextApiResponse } from 'next';

const config: Configuration = {
    okta: {
        clientId: process.env.OKTA_CLIENT_ID ?? '',
        clientSecret: process.env.OKTA_CLIENT_SECRET ?? '',
        orgDomain: process.env.OKTA_ORG_DOMAIN ?? '',
        publicUrl: process.env.NEXTAUTH_URL ?? '',
    },
    session: {
        strategy: 'jwt',
        // 8 hours for maxAge
        maxAge: 8 * 60 * 60,
    },
    callbacks: {
        redirect(url: string, baseUrl: string) {
            try {
                const parsedUrl = new URL(url, baseUrl);

                if (parsedUrl.origin === new URL(baseUrl).origin) {
                    return parsedUrl.toString();
                }

                console.error('Blocked invalid callback URL:', url);
                return baseUrl; // Default safe fallback
            } catch (err) {
                console.error('Error parsing callback URL:', url);
                return baseUrl;
            }
        },
    },
};

// Generate authentication options and nextAuth instance
export const { authOptions, nextAuth } = generateAuthConfiguration(config);

export default async function handler(
    req: NextApiRequest,
    res: NextApiResponse
) {
    res.setHeader('Cache-Control', 'private, no-store');
    return nextAuth(req, res);
}
